module.exports = __webpack_public_path__ + "media/newstyle/images/icon-donthave-148648ff66843a6c2cfd152c6dbf1453.svg";